
import CartService from '../services/cart-service'
// import CheckoutClientLogin from '../checkout/checkout-client-login.vue'
import UrlService from '../services/url-service';

// not using client-login, because it shows the checkout page after login
export default {
	components: {
		// CheckoutClientLogin,
	},
	props: ['modal'],
	// emits: ['go'],
	// data() {
	// 	return {
	// 	};
	// },
	created() {
		// hook the modal.dismiss(), because it can be called from outside the <template> by just pressing the ESC key
		let dis = this.modal.dismiss;
		this.modal.dismiss = (err) => {
			// this.$el.parentNode.parentNode.classList.remove('backdrop-blur-10');
			UrlService.go({name: 'accessdenied' });
			dis(err);
		};
	},
	mounted() {
		// this.$el.parentNode.parentNode.classList.add('backdrop-blur-10');
	},
	methods: {
		no() {
			// will call dis() in created()
			this.modal.dismiss();
		},
		yes() {
			CartService.cart.ageConfirmed = true;
			this.$el.parentNode.parentNode.classList.remove('backdrop-blur-10');
			this.modal.close();
		}
	}
}
